/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { WorkflowNodeData } from './workflow-node-data';

export abstract class WorkflowNode {
    id: number;
    name: string;
    type: WorkflowNodeType;
    
    data: WorkflowNodeData[];
    
    static toInstance<T>(instance: T, obj: Object): T {
        for (var propName in obj) {
            instance[propName] = obj[propName];
        }
        
        return instance;
    }
}

export enum WorkflowNodeType {
    CONDITION = 'COND',
    FUNCTION = 'FUNC',
    LOG = 'LOG',
    LOOP = 'LOOP',
    SERVICE = 'SERV'
}
